import api from 'api'
import {
  BulkLocationCreateData,
  BulkLocationCheckResponse,
  BulkLocationCreateResponse,
  BulkShiftCreateResponse,
  BulkShiftCreateRequest,
} from './types'
import { isAxiosError } from 'axios'

export const bulkLocationCheck = async ({
  locations,
}: BulkLocationCreateData): Promise<BulkLocationCheckResponse> => {
  try {
    const response = await api.post<BulkLocationCheckResponse>(
      `/admin/bulk_create_shifts/location_check`,
      {
        locations,
      }
    )

    return response.data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 400) {
      throw error.response.data
    }
    throw error
  }
}

export const bulkLocationCreate = async ({
  locations,
}: BulkLocationCreateData): Promise<BulkLocationCreateResponse> => {
  try {
    const response = await api.post<BulkLocationCreateResponse>(
      `/admin/bulk_create_shifts/location_create`,
      {
        locations,
      }
    )

    return response.data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 400) {
      throw error.response.data
    }
    throw error
  }
}

export const bulkShiftCreate = async ({
  shifts,
}: BulkShiftCreateRequest): Promise<BulkShiftCreateResponse> => {
  try {
    const response = await api.post<BulkShiftCreateResponse>(
      `/admin/bulk_create_shifts/shift_create`,
      {
        shifts,
      }
    )

    return response.data
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 400) {
      throw error.response.data
    }
    throw error
  }
}
